// <head> metadata for ConductorLicensePage (https://www.dbos.dev/conductor-license).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Conductor Software License',
    },
    {
      name: 'description',
      content:
        'The software license agreement that governs use of DBOS Conductor, the commercial control plane for operating DBOS durable workflows.',
    },
    {
      property: 'og:title',
      content: 'Conductor Software License',
    },
    {
      property: 'og:description',
      content:
        'The software license agreement that governs use of DBOS Conductor, the commercial control plane for operating DBOS durable workflows.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Conductor Software License',
    },
    {
      name: 'twitter:description',
      content:
        'The software license agreement that governs use of DBOS Conductor, the commercial control plane for operating DBOS durable workflows.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/conductor-license',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
